<template>
  <page-status class="order-detail" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="订单信息" />
      </van-cell>
      <van-cell title="订单号">{{ detail.poaCode }}</van-cell>
      <van-cell title="投保人姓名">{{ detail.phName }}</van-cell>
      <van-cell title="投保人身份证号码">{{ detail.identifyNo }}</van-cell>
      <van-cell title="车牌号">{{ detail.licenseNo || '新车未上牌' }}</van-cell>
      <van-cell title="车架号">{{ detail.frameNo }}</van-cell>
      <van-cell title="最后缴费日期">{{ detail.lastPayDate }}</van-cell>
      <van-cell title="保费合计">{{ detail.premium }}元</van-cell>
    </van-cell-group>

    <van-cell-group
      style="margin-top: 12px"
      v-for="(order, index) in detail.orderDetailes"
      :key="index"
    >
      <van-cell v-if="index === 0">
        <cell-header slot="title" title="投保单信息" />
      </van-cell>
      <van-cell title="投保单号">{{ order.bizNo }}</van-cell>
      <van-cell title="被保险人姓名">{{ order.insuredName }}</van-cell>
      <van-cell title="保费">{{ order.premium }}元</van-cell>
      <van-cell v-if="order.addressDetail" title="房屋地址">{{
        order.addressDetail
      }}</van-cell>
    </van-cell-group>

    <div class="submit-action">
      <van-button class="submit-btn" block type="info" @click="onGoPay">
        实名认证并支付
      </van-button>
    </div>

    <page-footer />
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import * as services from '@/services';

export default {
  name: 'OrderDetail',
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      detail: {
        orderDetailes: [],
      },
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { orderNo, proposalNo } = this.$route.query;
      services.getOrderDetail(orderNo, proposalNo).then(res => {
        this.detail = res.data;
        res.data.orderDetailes.forEach(item => {
          if (item.frameNo) {
            this.detail.frameNo = item.frameNo;
          }
          if (item.licenseNo) {
            this.detail.licenseNo = item.licenseNo;
          }
        });
        this.loading = false;
      });
    },

    onGoPay() {
      const { query } = this.$route;
      const { businessSource } = query;
      if (businessSource === 'ONLINE') {
        this.$router.push({ name: 'wechat-pay', query });
      } else {
        this.$router.push({ name: 'order-pay', query });
      }
    },
  },
};
</script>
<style lang="less">
.order-detail {
  .submit-action {
    margin: 32px 16px 0;
  }
}
</style>
